import React from 'react';
import TableIcon from '@mui/icons-material/GridOn';
import PivotTableChartIcon from '@mui/icons-material/PivotTableChart';
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import PieChartIcon from '@mui/icons-material/PieChart';
import BarChartIcon from '@mui/icons-material/Equalizer';
import LineChartIcon from '@mui/icons-material/ShowChart';
import NumberIcon from '@mui/icons-material/LooksOne';
import GaugeIcon from '@mui/icons-material/AvTimer';
import TreemapIcon from '@mui/icons-material/ViewQuilt';
import AreaIcon from '@mui/icons-material/NetworkCell';
import MapIcon from '@mui/icons-material/Map';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import DonutSmallIcon from '@mui/icons-material/DonutSmall';
import ShortTextIcon from '@mui/icons-material/ShortText';
import TrackChangesIcon from '@mui/icons-material/TrackChanges';
import { VizT } from 'components/ChartContainer/components/Chart/types';
import { VizType } from 'business/definitions';
import HorizontalBarChartIcon from 'components/icons/HorizontalBarChartIcon';

export const VIZ_CATEGORIES = [
    'table',
    'bar',
    'cartesian',
    'circular',
    'other',
] as const;

type Viz =
    | 'table'
    | 'pivot_table'
    | 'number'
    | 'paragraph'
    | 'gauge'
    | 'pie'
    | 'donut'
    | 'polar_bar'
    | 'bar'
    | 'horizontal_bar'
    | 'pyramid'
    | 'line'
    | 'scatterplot'
    | 'area'
    | 'treemap'
    | 'map'
    | 'advanced';

export const canCumulateVizTypes: VizType[] = [
    'table',
    'bar',
    'horizontal_bar',
    'line',
    'scatterplot',
    'area',
    'pivot_table',
    'polar_bar',
];

const vizInfos: Record<Viz, VizT> = {
    table: {
        name: 'table',
        icon: <TableIcon />,
        category: 'table',
    },
    pivot_table: {
        name: 'pivot_table',
        icon: <PivotTableChartIcon />,
        category: 'table',
    },
    number: {
        name: 'number',
        icon: <NumberIcon />,
        category: 'other',
    },
    paragraph: {
        name: 'paragraph',
        icon: <ShortTextIcon />,
        category: 'other',
    },
    gauge: {
        name: 'gauge',
        icon: <GaugeIcon />,
        category: 'circular',
    },
    pie: {
        name: 'pie',
        icon: <PieChartIcon />,
        category: 'circular',
    },
    donut: {
        name: 'donut',
        icon: <DonutSmallIcon />,
        category: 'circular',
    },
    polar_bar: {
        name: 'polar_bar',
        icon: <TrackChangesIcon style={{ transform: 'scaleX(-1)' }} />,
        category: 'circular',
    },
    bar: {
        name: 'bar',
        icon: <BarChartIcon />,
        category: 'bar',
    },
    horizontal_bar: {
        name: 'horizontal_bar',
        icon: <HorizontalBarChartIcon />,
        category: 'bar',
    },
    pyramid: {
        name: 'pyramid',
        icon: <HorizontalBarChartIcon />,
        category: 'bar',
    },
    line: {
        name: 'line',
        icon: <LineChartIcon />,
        category: 'cartesian',
    },
    scatterplot: {
        name: 'scatterplot',
        icon: <BubbleChartIcon />,
        category: 'cartesian',
    },
    area: {
        name: 'area',
        icon: <AreaIcon />,
        category: 'cartesian',
    },
    treemap: {
        name: 'treemap',
        icon: <TreemapIcon />,
        category: 'other',
    },
    map: {
        name: 'map',
        tooltip: 'Carte',
        icon: <MapIcon />,
        category: 'other',
    },
    // Hack for demo to be able to insert advanced eCharts
    // Unusable for regular clients
    advanced: {
        name: 'advanced',
        tooltip: 'Avancé',
        icon: <AcUnitIcon />,
        category: 'other',
    },
};

export default vizInfos;
